import { captureException } from "@sentry/react";
import { AxiosInstance } from "axios";
import { Dispatch } from "redux";
import { showNotification } from "../../notification/actions";
import { CHANGE_TASK_DESCRIPTION } from "../types";
import { IStateTree } from "../../interfaces";
import { PlanActionTypes } from "../models/planActions";

export default (data: { planId: string, index: number, description: string }) => async (dispatch: Dispatch<PlanActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
    try {
        await api.post("/change-task-description", data);
        dispatch({
            type: CHANGE_TASK_DESCRIPTION,
            payload: data,
        });
        return true;
    } catch (error) {
        dispatch(showNotification(error.toString(), "warning"));
        captureException(error);
        return false;
    }
};